import { FETCH_NAVIGATION_FAILURE, FETCH_NAVIGATION_REQUEST, FETCH_NAVIGATION_SUCCESS } from './dynamicNavigation.actionsType';

export const NAVIGATION = 'dynamicNavigation';

let initialState = {
    loading: false,
    dynamicNavigation: [],
    errorMessage: ''
};

export let navigationReducer = (state = initialState, action) => {
    let { type, payload } = action;

    switch (type) {
        case FETCH_NAVIGATION_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_NAVIGATION_SUCCESS:
            return {
                ...state,
                loading: false,
                dynamicNavigation: payload
            };
        case FETCH_NAVIGATION_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: payload
            };
        default:
            return state;
    }
};
